module.exports = __webpack_public_path__ + "uz.svg?0b281dd521d66869cfba6fc17b814b19";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/uz.svg
// module id = 1424
// module chunks = 0